module.exports = __webpack_public_path__ + "img/pbanner.b90ec811.png";